import { Form, Modal, ModalBuilder } from "@redriver/cinnamon";
import React from "react";
import { Button } from "semantic-ui-react";
import { uploadDocument } from "./actions";

const UploadRepFile = ({ bookingId, onRefresh }) => {
  return (
    <ModalBuilder
      withForm
      submitAction={uploadDocument}
      submitParams={bookingId}
      onSubmitted={onRefresh}
      renderTrigger={(fire) => (
        <Button primary onClick={fire}>
          Upload Document
        </Button>
      )}
      renderModal={(modalProps, formProps) => {
        return (
          <Modal.Add {...modalProps} header="Upload Document">
            <Form {...formProps}>
              <Form.FileUpload
                field="file"
                required
                label="Select Document"
                fluid
              />
            </Form>
          </Modal.Add>
        );
      }}
    />
  );
};

export default UploadRepFile;
